import { apiPost, operationsClient } from '@/lib/api';
import { signatureEndpoints } from '@/lib/api/endpoints';

/**
 * Upload a captured signature image (a PNG data URL from SignaturePad) to S3 via
 * a presigned URL and return the stored file URL. Used by the work-authorization
 * and completion sign-off collect flows (NOT-298).
 */
export async function uploadSignatureImage(dataUrl: string): Promise<string> {
  const blob = await (await fetch(dataUrl)).blob();
  const { uploadUrl, fileUrl } = await apiPost<{ uploadUrl: string; fileUrl: string }>(
    operationsClient,
    signatureEndpoints.uploadUrl(),
  );
  const res = await fetch(uploadUrl, {
    method: 'PUT',
    body: blob,
    headers: { 'Content-Type': 'image/png' },
  });
  if (!res.ok) {
    throw new Error(`Signature upload failed (${res.status})`);
  }
  return fileUrl;
}
